import axios from '@/utils/axiosHelper';

// 分享配置
export const GetShareAPI = ({ uri }) => {
  return axios({ url: '/wechat/jssdk', method: 'POST', data: { uri } });
};

// 短链生成
export const generateSortLink = (url) => {
  return axios({ url: '/jump/short', method: 'POST', data: { url } });
};

// 生成前往wiki的链接
export const generateWikiLink = (params) => {
  return axios({ url: '/integral/scheme', method: 'GET', params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/api/active.js